export enum DailyLoadStatusType {
  FILES_EXPECTED = 'FILES_EXPECTED',
  FILES_RECEIVED = 'FILES_RECEIVED',
  SOME_FILES_RECEIVED = 'SOME_FILES_RECEIVED',
  PAST_DUE = 'PAST_DUE',
  FILES_RECEIVED_LATE = 'FILES_RECEIVED_LATE',
}

export default DailyLoadStatusType;
